var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex flex-item1 mar20-b goods-list" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.orderGoodsList,
              "header-row-class-name": "gray3 tab-header",
              border: "",
              "cell-class-name": "cell-td"
            }
          },
          [
            _c(
              "el-table-column",
              {
                attrs: { width: "500px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex pad15-lr pad15-b",
                            class: {
                              "border-b": scope.row.orderGoodsGiftBo.length > 0
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "overflow flex-shrink mar12-r wh72"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      scope.row.goodsPic +
                                      "?imageView2/1/w/72/h/72"
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-auto flex flex-column justify-between"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "gray3 lh20" },
                                  [
                                    scope.row.optimizationCard == 1
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "mar5-r",
                                            attrs: {
                                              type: "danger",
                                              size: "mini"
                                            }
                                          },
                                          [_vm._v("优选")]
                                        )
                                      : _vm._e(),
                                    scope.row.cfyCard == 1
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "mar5-r",
                                            attrs: {
                                              type: "danger",
                                              size: "mini"
                                            }
                                          },
                                          [_vm._v("处方药")]
                                        )
                                      : _vm._e(),
                                    scope.row.preventCard == 1
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "mar5-r",
                                            attrs: {
                                              type: "danger",
                                              size: "mini"
                                            }
                                          },
                                          [_vm._v("防非")]
                                        )
                                      : _vm._e(),
                                    scope.row.goodsTagList &&
                                    scope.row.goodsTagList.length
                                      ? _vm._l(scope.row.goodsTagList, function(
                                          tag
                                        ) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: tag,
                                              staticClass: "mar5-r",
                                              attrs: {
                                                type: "danger",
                                                size: "mini"
                                              }
                                            },
                                            [_vm._v(_vm._s(tag))]
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.goodsName) +
                                        "\n              "
                                    )
                                  ],
                                  2
                                ),
                                _c("div", { staticClass: "gray9 mar4-t" }, [
                                  _vm._v(_vm._s(scope.row.goodsSpec))
                                ])
                              ]
                            )
                          ]
                        ),
                        scope.row.orderGoodsGiftBo.length > 0
                          ? _c(
                              "div",
                              _vm._l(scope.row.orderGoodsGiftBo, function(
                                gift,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: gift.id,
                                    staticClass: "flex pad15-lr pad15-tb",
                                    class: { "border-t": index }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overflow flex-shrink mar12-r wh72"
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              gift.giftGoodsPicUrl +
                                              "?imageView2/1/w/72/h/72"
                                          }
                                        })
                                      ]
                                    ),
                                    _c("div", { staticClass: "flex-auto" }, [
                                      _c("div", { staticClass: "gray3 lh20" }, [
                                        _vm._v(_vm._s(gift.giftGoodsName))
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "gray9 mar4-t" },
                                        [_vm._v(_vm._s(gift.giftGoodsSpec))]
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              },
              [_c("template", { slot: "header" }, [_vm._v("货品")])],
              2
            ),
            _c("el-table-column", {
              attrs: { align: "center", label: "价格" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.sellPrice && !_vm.dataMasking
                        ? _c("div", { staticClass: "f12 price-line" }, [
                            _vm._v("¥ " + _vm._s(scope.row.sellPrice))
                          ])
                        : _vm._e(),
                      _vm.dataMasking
                        ? _c(
                            "div",
                            {
                              staticClass: "gray3 mar30-t",
                              staticStyle: { height: "58px" }
                            },
                            [_vm._v("****")]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "gray3 mar30-t",
                              class: {
                                "line-after":
                                  scope.row.orderGoodsGiftBo &&
                                  scope.row.orderGoodsGiftBo.length
                              },
                              staticStyle: { height: "58px" }
                            },
                            [
                              _vm._v(
                                "\n            ¥ " +
                                  _vm._s(scope.row.sellFactPrice) +
                                  "\n          "
                              )
                            ]
                          ),
                      scope.row.orderGoodsGiftBo.length > 0
                        ? _vm._l(scope.row.orderGoodsGiftBo, function(
                            gift,
                            index
                          ) {
                            return _c("div", {
                              key: gift.id,
                              staticClass: "h103",
                              class: {
                                "line-after":
                                  index != scope.row.orderGoodsGiftBo.length - 1
                              }
                            })
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "c", align: "center", label: "数量" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm.dataMasking
                        ? _c(
                            "div",
                            {
                              staticClass: "gray3 mar30-t",
                              staticStyle: { height: "58px" }
                            },
                            [_vm._v("****")]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "gray3 mar30-t",
                              class: {
                                "line-after":
                                  scope.row.orderGoodsGiftBo &&
                                  scope.row.orderGoodsGiftBo.length
                              },
                              staticStyle: { height: "58px" }
                            },
                            [
                              _vm._v(
                                "\n            x " +
                                  _vm._s(scope.row.goodsQuantity) +
                                  "\n          "
                              )
                            ]
                          ),
                      scope.row.orderGoodsGiftBo.length > 0
                        ? _c(
                            "div",
                            _vm._l(scope.row.orderGoodsGiftBo, function(
                              gift,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: gift.id,
                                  staticClass:
                                    "flex justify-center items-center flex-column h103",
                                  class: {
                                    "line-after":
                                      index !=
                                      scope.row.orderGoodsGiftBo.length - 1
                                  }
                                },
                                [
                                  _c("div", { staticClass: "gray3" }, [
                                    _vm._v("x " + _vm._s(gift.giftQuantity))
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "flex justify-center" },
                                    [
                                      _c("div", { staticClass: "gift" }, [
                                        _vm._v(
                                          _vm._s(
                                            gift.promotionDtlId &&
                                              gift.promotionDtlId != "0"
                                              ? "赠品"
                                              : "套餐"
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "d", align: "center", label: "实际收货数量" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "fb gray3 justify-center mar30-t flex" },
                        [
                          _vm.dataMasking
                            ? _c("div", [_vm._v("****")])
                            : scope.row.orderRefundGoodsBo.goodsQuantityAccum >=
                              0
                            ? _c("div", [
                                _vm._v(
                                  "\n              x " +
                                    _vm._s(
                                      (
                                        Math.round(
                                          (scope.row.goodsQuantity -
                                            scope.row.orderRefundGoodsBo
                                              .goodsQuantityAccum) *
                                            100 +
                                            Number.EPSILON
                                        ) / 100
                                      ).toFixed(2)
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "e", align: "center", label: "金额" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "fb gray3 justify-center mar30-t flex" },
                        [
                          _c("div", { staticClass: "pad2-r" }, [_vm._v("¥")]),
                          _vm.dataMasking
                            ? _c("div", [_vm._v("****")])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(
                                    (
                                      Math.round(
                                        scope.row.goodsQuantity *
                                          scope.row.sellFactPrice *
                                          100 +
                                          Number.EPSILON
                                      ) / 100
                                    ).toFixed(2)
                                  )
                                )
                              ])
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm.orderGoodsGiftBoList && _vm.orderGoodsGiftBoList.length > 0
      ? _c(
          "div",
          { staticClass: "flex flex-item1 mar20-b" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.orderGoodsGiftBoList,
                  "header-row-class-name": "gray3 tab-header",
                  border: "",
                  "cell-class-name": "cell-td"
                }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "", align: "", label: "赠品" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "overflow flex-shrink mar12-r wh72"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        scope.row.giftGoodsPicUrl +
                                        "?imageView2/1/w/72/h/72"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-column justify-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "gray3 lh20" },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "mar5-r",
                                          attrs: {
                                            type: "danger",
                                            size: "mini"
                                          }
                                        },
                                        [_vm._v("赠品")]
                                      ),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(scope.row.giftGoodsName) +
                                          "\n              "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    685148814
                  )
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "giftQuantity",
                    align: "center",
                    label: "数量"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.giftQuantity > 0
                              ? _c("div", { staticClass: "gray3" }, [
                                  _vm._v("x " + _vm._s(scope.row.giftQuantity))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1484091659
                  )
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }